import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=8036a4ac&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=8036a4ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8036a4ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8036a4ac')) {
      api.createRecord('8036a4ac', component.options)
    } else {
      api.reload('8036a4ac', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=8036a4ac&scoped=true&", function () {
      api.rerender('8036a4ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Si36eypDqa1c/JS/comp/SearchFilterTokens.vue"
export default component.exports